import { fixedBondStore, floatingBondStore } from './bonds';
import { getCdsItems } from './cds';
import { getCreditCurves } from './creditCurves';
import { getSavedCurves } from './curves';
import { getQuoteBook } from './quoteBook';
import { getIrSwaps } from './swaps';
import { getInflationSwaps } from './inflationSwaps';
import { getSwaptionModels } from './swaptionModels';
import { getSwaptions } from './swaptions';
import { getVolSurfaces } from './volSurfaces';
import { listEquityOptions } from './equityOptions';

export interface DataOverviewStats {
  indices: number;
  curves: number;
  curveSets: number;
  quotes: number;
  quoteBookEntries: number;
  volSurfaces: number;
  creditCurves: number;
  fixedBonds: number;
  floatingBonds: number;
  swaps: number;
  inflationSwaps: number;
  swaptions: number;
  swaptionModels: number;
  cds: number;
  equityOptions: number;
  total: number;
}

function readArray<T = unknown>(key: string): T[] {
  try {
    const raw = localStorage.getItem(key);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export async function loadDataOverviewStats(): Promise<DataOverviewStats> {
  const [fixedBonds, floatingBonds, swaps, inflationSwaps, swaptions, cds, equityOptions] = await Promise.all([
    fixedBondStore.getAll(),
    floatingBondStore.getAll(),
    getIrSwaps(),
    getInflationSwaps(),
    getSwaptions(),
    getCdsItems(),
    listEquityOptions(),
  ]);

  const counts = {
    indices: readArray('quantra_indices').length,
    curves: getSavedCurves().length,
    curveSets: readArray('quantra_curve_sets').length,
    quotes: readArray('quantra_quotes').length,
    quoteBookEntries: getQuoteBook().length,
    volSurfaces: getVolSurfaces().length,
    creditCurves: getCreditCurves().length,
    fixedBonds: fixedBonds.length,
    floatingBonds: floatingBonds.length,
    swaps: swaps.length,
    inflationSwaps: inflationSwaps.length,
    swaptions: swaptions.length,
    swaptionModels: getSwaptionModels().length,
    cds: cds.length,
    equityOptions: equityOptions.length,
  };

  return {
    ...counts,
    total: Object.values(counts).reduce((acc, v) => acc + v, 0),
  };
}
